<template>
  <van-tabbar v-model="active">
    <van-tabbar-item icon="home-o" @click="handleClick(0)">首页</van-tabbar-item>
    <van-tabbar-item icon="friends-o" @click="handleClick(1)">我的</van-tabbar-item>
  </van-tabbar>
</template>
<script>
export default {
  props: {
    act: {
      default: 0,
      type: Number
    }
  },
  data() {
    return {
        active: 0
    };
  },
  mounted(){
    this.active = this.act
  },
  methods: {
    handleClick(e){
      this.$router.push(e ? './my' :'./index')
    }
  }
};
</script>